import { render, staticRenderFns } from "./FollowPanel.vue?vue&type=template&id=b8ce2d3c&scoped=true&"
import script from "./FollowPanel.vue?vue&type=script&lang=js&"
export * from "./FollowPanel.vue?vue&type=script&lang=js&"
import style0 from "./FollowPanel.vue?vue&type=style&index=0&id=b8ce2d3c&prod&scoped=true&lang=css&"
import style1 from "./FollowPanel.vue?vue&type=style&index=1&id=b8ce2d3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ce2d3c",
  null
  
)

export default component.exports